import React from 'react';
import './App.css';

import GuestRoom from './supportingUI/guestRoom';

function App(){
    return(
        <GuestRoom/>
    )
}

export default App;